import { render } from "./SavedViewSelection.vue?vue&type=template&id=671ca0c8&scoped=true"
import script from "./SavedViewSelection.vue?vue&type=script&lang=js"
export * from "./SavedViewSelection.vue?vue&type=script&lang=js"

import "./SavedViewSelection.vue?vue&type=style&index=0&id=671ca0c8&lang=scss"
import "./SavedViewSelection.vue?vue&type=style&index=1&id=671ca0c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671ca0c8"]])

export default __exports__